<template>
  <div>
    <br/>
    <br/>
    姓名:
    <a-input v-model="name" placeholder="请输入您的姓名" style="max-width: 300px;width: 80%"/>
    <br/>
    选择你最喜欢的节目:<br/>
    <a-radio-group v-model="value">
      <a-radio style="display: flex" :value=this.list[0]>漂泊的人-叶娇</a-radio>
      <a-radio style="display: flex" :value=this.list[1]>五世请缨-吕盼玲</a-radio>
      <a-radio style="display: flex" :value=this.list[2]>红尘情歌-张荷花,王娟</a-radio>
      <a-radio style="display: flex" :value=this.list[3]>三句半祝南华再创佳绩-刘秀丽,唐晓凤,董衬,王钰,翟庭超</a-radio>
      <a-radio style="display: flex" :value=this.list[4]>男孩-鲁兴发</a-radio>
      <a-radio style="display: flex" :value=this.list[5]>舞蹈串烧-贾丽娜,李甜甜</a-radio>
      <a-radio style="display: flex" :value=this.list[6]>丫头-孟令虎</a-radio>
      <a-radio style="display: flex" :value=this.list[7]>女儿情-邓逢元</a-radio>
      <a-radio style="display: flex" :value=this.list[8]>我心永恒-刘玉荣</a-radio>
      <a-radio style="display: flex" :value=this.list[9]>喜欢你-李叶茸</a-radio>
    </a-radio-group>
    <br/>
    <a-button type="primary" @click="checkAndSubmit">确认提交</a-button>
    <a id="result" style="visibility: hidden" href="voteResult">查看结果</a>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "vote",
  data() {
    return {
      list:[
        "漂泊的人-叶娇",
        "五世请缨-吕盼玲",
        "红尘情歌-张荷花,王娟",
        "三句半祝南华再创佳绩-刘秀丽,唐晓凤,董衬,王钰,翟庭超",
        "男孩-鲁兴发",
        "舞蹈串烧-贾丽娜,李甜甜",
        "丫头-孟令虎",
        "女儿情-邓逢元",
        "我心永恒-刘玉荣",
        "喜欢你-李叶茸",
      ],
      name: "",
      value: "漂泊的人",
      data: "",
    };
  },
  methods: {
    checkAndSubmit() {
      if (this.name == "" || this.name == null) {
        alert("请输入姓名");
        return;
      }
      axios.get("http://www.tcnanhua.com:5555/t-nh-vote/updateTNhVote?name=" + this.name + "&vote=" + this.value)
        .then((res) => {
          this.data = res.data.data;
          if (this.data > 0) {
            this.$message.success('提交成功,请勿重复提交');
            document.getElementById("result").style.visibility="visible";
          } else {
            this.$message.error('提交失败,请正确输入姓名');
          }
        });
    }
  }
}
</script>

<style scoped>
a-radio {
  display: flex;
}
</style>



// WEBPACK FOOTER //
// src/components/Vote.vue